package com.evoapps.evoshift.domain.usecase

import com.evoapps.evoshift.domain.model.User
import com.evoapps.evoshift.domain.repository.UserRepository

class UpdateUserProfileUseCase(
    private val userRepository: UserRepository
) {
    suspend operator fun invoke(user: User): Result<Unit> {
        return try {
            if (user.displayName.isBlank()) {
                throw IllegalArgumentException("Display name cannot be empty")
            }
            userRepository.updateUserProfile(user).getOrThrow()
            Result.success(Unit)
        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}